import { render, staticRenderFns } from "./inputForm.vue?vue&type=template&id=749fc109&scoped=true&"
import script from "./inputForm.vue?vue&type=script&lang=js&"
export * from "./inputForm.vue?vue&type=script&lang=js&"
import style0 from "./inputForm.vue?vue&type=style&index=0&id=749fc109&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749fc109",
  null
  
)

export default component.exports